import React, { useState } from 'react';
import "../Styles/GalleryPopUp.css";
import GalleryGrid from './GalleryGrid';

const GalleryPopUp = ({ handleClosePopup, galleryData }) => {
  const [activeLayout, setActiveLayout] = useState('layout-1'); // layout-1 or layout-3
  const [activeSectionIndex, setActiveSectionIndex] = useState(0); // index of selected title
  const [currentIndex, setCurrentIndex] = useState(0); // for layout-1 image scroll

  const activeSection = galleryData[activeSectionIndex];
  const activeItems = activeSection.items || [];
  const activeTitle = activeSection.title;

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? activeItems.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === activeItems.length - 1 ? 0 : prev + 1));
  };

  const handleTitleClick = (index) => {
    setActiveSectionIndex(index);
    setCurrentIndex(0); // reset image index
  };

  return (
    <div className='Gallery-pop-up-holder' onClick={handleClosePopup}>
      <div className='Gallery-pop-up-section' onClick={(e) => e.stopPropagation()}>
        <div className='Gallery-pop-up-top-container'>
          {/* Titles */}
          <div className='Gallery-pop-up-top-container-titles'>
            {galleryData.map((section, index) => (
              <div
                key={index}
                className={activeSectionIndex === index ? 'active' : ''}
                onClick={() => handleTitleClick(index)}
              >
                {section.title}
              </div>
            ))}
          </div>

          {/* Layout selector */}
          <div className='Gallery-pop-up-top-image-layout-icon-holders'>
            <div
              className={`Gallery-pop-up-top-image-layout-icon-item ${activeLayout === 'layout-1' ? 'active' : ''}`}
              onClick={() => setActiveLayout('layout-1')}
            >
              <img src={require('../Resource/Gallery/layoutIcons/oneSquare.png')} alt="Layout 1" />
            </div>
            <div
              className={`Gallery-pop-up-top-image-layout-icon-item ${activeLayout === 'layout-3' ? 'active' : ''}`}
              onClick={() => setActiveLayout('layout-3')}
            >
              <img src={require('../Resource/Gallery/layoutIcons/fourSquare.png')} alt="Layout 3" />
            </div>
          </div>
        </div>

        {/* Layout Section */}
        <div className='Gallery-pop-up-bottom-container-holds-layouts'>
          {/* Layout 1 - Slider */}
          {activeLayout === 'layout-1' && (
            <div className='Gallery-pop-up-bottom-container-holds-layouts-layout-1'>
              <span className='layout-1-left-arrow' onClick={handlePrev}></span>

              <div className='Gallery-pop-up-bottom-container-holds-layouts-layout-1-image-holder'>
                {activeSection.type === 'image' ? (
                  <img src={activeItems[currentIndex]} alt={`image-${currentIndex}`} />
                ) : (
                  <video
                    src={activeItems[currentIndex]}
                    controls
                    autoPlay
                    muted
                    loop
                    style={{ width: '100%',height:'100%', borderRadius: '1vw' }}
                  />
                )}
              </div>

              <span className='layout-1-right-arrow' onClick={handleNext}></span>
            </div>
          )}

          {/* Layout 3 - Grid */}
          {activeLayout === 'layout-3' && (
            <div className='Gallery-pop-up-bottom-container-holds-layouts-layout-3'
            style={{ paddingTop: activeItems.length > 2 ? '0vw' : '0' }}
            >
              <GalleryGrid items={activeItems} type={activeSection.type} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default GalleryPopUp;
